import InputCustom from 'components/Inputs'
import CustomSelect from 'components/Select'
import useRedux from 'hooks/useRedux'
import { useEffect } from 'react'
import { FiSettings } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import * as campanhaActions from 'store/modules/backoffice/campanha/actions'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import { SimpleTitleCard } from 'styles/global'

const variaveisOptions = [
  { campoEquivalente: 'nome', descricao: '{{nome}}' },
  { campoEquivalente: 'cpf', descricao: '{{cpf}}' }
]

const getVariaveisSelecionadas = (rawValue: string | null): string[] => {
  if (!rawValue) {
    return []
  }

  return rawValue
    .split(',')
    .map((item) => item.trim())
    .filter((item) =>
      variaveisOptions.some((opt) => opt.campoEquivalente === item)
    )
}

const ElevenLabs = () => {
  const {
    register,
    agentesElevenLabs,
    numerosOrigemElevenLabs,
    invalidsTabDiscador,
    visualizacao
  } = useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)

  const { dispatch } = useRedux()

  const agentesOptions = agentesElevenLabs
    .map((agente) => {
      const agenteRaw = agente as unknown as Record<string, string>
      const label =
        agenteRaw.nome || agenteRaw.name || agenteRaw.descricao || ''
      const id =
        agenteRaw.agenteId ||
        agenteRaw.agentId ||
        agenteRaw.id ||
        agenteRaw.identifier ||
        label

      return { id, label }
    })
    .filter((agente) => Boolean(agente.id && agente.label))

  const numerosOrigemOptions = numerosOrigemElevenLabs.map((numero) => ({
    ...numero,
    label: numero.descricao
      ? `${numero.phoneNumber} - ${numero.descricao}`
      : numero.phoneNumber
  }))

  const agenteSelecionado = agentesOptions.find(
    (agente) =>
      agente.id === register.agentesElevenLabsId ||
      agente.label === register.agentesElevenLabsId
  )

  const numeroOrigemSelecionado = numerosOrigemOptions.find(
    (numero) =>
      numero.id === register.numerosOrigemElevenLabsId ||
      numero.descricao === register.numerosOrigemElevenLabsId ||
      numero.phoneNumber === register.numerosOrigemElevenLabsId ||
      numero.label === register.numerosOrigemElevenLabsId
  )

  useEffect(() => {
    if (
      agenteSelecionado?.id &&
      agenteSelecionado.id !== register.agentesElevenLabsId
    ) {
      dispatch(
        campanhaActions.setRegisterFields(
          agenteSelecionado.id,
          'agentesElevenLabsId'
        )
      )
    }
  }, [agenteSelecionado, dispatch, register.agentesElevenLabsId])

  useEffect(() => {
    if (
      numeroOrigemSelecionado?.id &&
      numeroOrigemSelecionado.id !== register.numerosOrigemElevenLabsId
    ) {
      dispatch(
        campanhaActions.setRegisterFields(
          numeroOrigemSelecionado.id,
          'numerosOrigemElevenLabsId'
        )
      )
    }
  }, [numeroOrigemSelecionado, dispatch, register.numerosOrigemElevenLabsId])

  useEffect(() => {
    if (register.tipoCampanhaCrmId === '58dbb40f-ff45-4a29-8375-fcc9bb726d1f') {
      dispatch(campanhaActions.getAgentesElevenLabsSaga())
      dispatch(campanhaActions.getNumerosOrigemElevenLabsSaga())
    }
  }, [dispatch, register.tipoCampanhaCrmId])

  return (
    <div className="d-flex flex-column row-gap-10">
      <SimpleTitleCard>
        <FiSettings className="icon" /> Configurações ElevenLabs
      </SimpleTitleCard>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={4}>
          <label className="label-12">Agendar para</label>
          <Row className="g-2">
            <Col md={6}>
              <InputCustom
                type="date"
                value={register.agendarPara || ''}
                disabled={visualizacao}
                onChange={(e) => {
                  dispatch(
                    campanhaActions.setRegisterFields(
                      e.target.value || null,
                      'agendarPara'
                    )
                  )
                }}
              />
            </Col>
            <Col md={6}>
              <InputCustom
                type="time"
                value={register.agendarHora || ''}
                disabled={visualizacao}
                onChange={(e) => {
                  dispatch(
                    campanhaActions.setRegisterFields(
                      e.target.value || null,
                      'agendarHora'
                    )
                  )
                }}
              />
            </Col>
          </Row>
        </Col>

        <Col className="d-flex flex-column justify-content-end" md={4}>
          <label className="label-12">Agente de Voz*</label>
          <CustomSelect
            options={agentesOptions}
            isMulti={false}
            placeholder="Selecione"
            onChange={(e) => {
              dispatch(campanhaActions.setInvalidsTabDiscador(!e, 'agenteVoz'))
              dispatch(
                campanhaActions.setRegisterFields(e, 'agentesElevenLabsId')
              )
            }}
            disabled={visualizacao}
            value={agenteSelecionado?.id || register.agentesElevenLabsId}
            accessorLabel="label"
            accessorValue="id"
            invalid={invalidsTabDiscador.agenteVoz}
            message="Agente de voz é obrigatório"
          />
        </Col>

        <Col className="d-flex flex-column justify-content-end" md={4}>
          <label className="label-12">Número de Origem</label>
          <CustomSelect
            options={numerosOrigemOptions}
            isMulti={false}
            placeholder="Selecione"
            onChange={(e) => {
              dispatch(
                campanhaActions.setRegisterFields(
                  e,
                  'numerosOrigemElevenLabsId'
                )
              )
            }}
            disabled={visualizacao}
            value={
              numeroOrigemSelecionado?.id || register.numerosOrigemElevenLabsId
            }
            accessorLabel="label"
            accessorValue="id"
          />
        </Col>
      </Row>
      <Row className="d-flex row-gap-15">
        <Col md={4}>
          <label className="label-12">Variáveis</label>
          <CustomSelect
            options={variaveisOptions}
            isMulti
            placeholder="Selecione"
            onChange={(e) => {
              const values = Array.isArray(e) ? e : []
              const variaveis = values.join(',')

              dispatch(
                campanhaActions.setRegisterFields(
                  variaveis || null,
                  'variaveis'
                )
              )
            }}
            disabled={visualizacao}
            value={getVariaveisSelecionadas(register.variaveis)}
            accessorLabel="descricao"
            accessorValue="campoEquivalente"
          />
        </Col>
        <Col md={4}>
          <label className="label-12">Tempo limite de toque (segundos)</label>
          <InputCustom
            type="number"
            value={register.tempoLimiteToque ?? ''}
            min={1}
            max={999}
            disabled={visualizacao}
            onChange={(e) => {
              const val = e.target.value === '' ? null : Number(e.target.value)
              dispatch(
                campanhaActions.setRegisterFields(
                  val !== null && val >= 1 && val <= 999 ? val : null,
                  'tempoLimiteToque'
                )
              )
            }}
          />
        </Col>
        <Col md={4}>
          <label className="label-12">Limite de concorrência (opcional)</label>
          <InputCustom
            type="number"
            value={register.limiteConcorrencia ?? ''}
            min={1}
            disabled={visualizacao}
            onChange={(e) => {
              const val = e.target.value === '' ? null : Number(e.target.value)
              dispatch(
                campanhaActions.setRegisterFields(
                  val !== null && val >= 1 ? val : null,
                  'limiteConcorrencia'
                )
              )
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default ElevenLabs
